import React from 'react'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import SteperBooking from '../Components/SteperBooking/SteperBooking'
import TopNavbar from '../Components/TopNavbar/TopNavbar'

const BookPage = () => {
  return (
    <>
    <div className='bookPageMain'>
    <TopNavbar/>
    <Header/>
    <SteperBooking/>

<ContactUs/>
    <Footer/>
    </div>
    </>
  )
}

export default BookPage